class QuickCart {
  constructor() {
    this.init();
  }

  slider = () => {
    const swiperEl = document.querySelector('.quick-cart-announcement-js');
    if (!swiperEl) return;
    const autoplayDuration = swiperEl.getAttribute("data-autoplay");

    new Swiper(swiperEl, {
      loop: true,
      autoplay: {
        delay: autoplayDuration,
        disableOnInteraction: false
      }
    });
  }

  clickEvent = () => {
    document.addEventListener("click", function (e) {
      const closePopp = document.querySelector(".quick-cart__close-icon[data-modal-close]");
      if (e.target.classList.contains("continue-close-cart") || e.target.closest(".continue-close-cart")) {
        e.preventDefault();
        if (closePopp) closePopp.click();
      }
    }, { passive: false });

    document.addEventListener("touchend", function (e) {
      const closePopp = document.querySelector(".quick-cart__close-icon[data-modal-close]");

      if (e.target.classList.contains("continue-close-cart") || e.target.closest(".continue-close-cart")) {
        e.preventDefault();
        if (closePopp) closePopp.click();
      }
    }, { passive: false });
  };

  textMoreToggle = () => {
    const readMore = document.querySelector(".seo-section .seo-section__inner .seo-content-items .seo-content-data .read-more")
    const readLess = document.querySelector(".seo-section .seo-section__inner .seo-content-items .seo-content-data .read-less")
    const toggleClass = document.querySelector(".seo-section .seo-section__inner .seo-content-items")
    if (readMore) {
      readMore.addEventListener("click", () => {
        toggleClass.classList.remove("active")
        readMore.style.display = "none"
        readLess.style.display = "block"
      })
    }
    if (readLess) {
      readLess.addEventListener("click", () => {
        toggleClass.classList.add("active")
        readMore.style.display = "block"
        readLess.style.display = "none"
      })
    }
  }

  init() {
    this.clickEvent()
    this.textMoreToggle()
    this.slider();
  }
}


new QuickCart();